import React, { Component } from 'react';
import { createRef } from 'react';
import { OverlayTrigger, Popover, Button } from 'react-bootstrap';

import './PopConfirm.css';
import InlineConfirm from './InlineConfirm';

class PopConfirm extends Component {
  cancelButtonRef: any;

  constructor(props) {
    super(props);

    this.cancelButtonRef = createRef();
  }

  handleOnCancel = () => {
    const { onAction } = this.props;

    this.cancelButtonRef.current.click();

    !!onAction && onAction('cancel');
  }

  handleOnConfirm = () => {
    const { onAction } = this.props;

    this.cancelButtonRef.current.click();

    !!onAction && onAction('confirm');
  }

  getPopover = () => {
    const { title, text, confirmOkText, confirmCancelText } = this.props;

    return (
      <Popover id="popover-popconfirm" className="popconfirm">
        { !!title && <Popover.Title as="h3">{ title }</Popover.Title> }
        <Popover.Content>
          <div className="popconfirm-content">
            <span role="img" aria-label="exclamation-circle" className="icon exclamation-circle mr-1">
              <svg viewBox="64 64 896 896" focusable="false" data-icon="exclamation-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"></path></svg>
            </span>
            { text }
          </div>

          <div className="popconfirm-buttons">
            <Button type="button"
                variant="secondary"
                size="sm"
                onClick={ this.handleOnCancel.bind(this) }
              >
              { confirmCancelText || 'No' }
            </Button>
            <Button type="button"
                variant="primary"
                size="sm"
                className="ml-2"
                onClick={ this.handleOnConfirm.bind(this) }
              >
              { confirmOkText || 'Yes' }
            </Button>
          </div>
        </Popover.Content>
      </Popover>
    );
  }

  render() {
    const { children, placement = 'top', variant="overlay" } = this.props;

    if (variant === 'inline') {
      return <InlineConfirm { ...this.props } />
    }

    return (
      <OverlayTrigger trigger="click" placement={ placement } overlay={ this.getPopover() }>
        <div className="popover-popconfirm">
          { children }

          <Button type="button"
            bsPrefix="d-none d-none"
            ref={ this.cancelButtonRef }
          >
            Dismiss
          </Button>
        </div>
      </OverlayTrigger>
    )
  }
}

export default PopConfirm;